import { Box, CircularProgress, TextField, Tooltip, Typography, useTheme } from "@mui/material"
import { BlackDownloadIcon, SearchIcon } from "../../assets/SvgIcons"
import CustomTable from "../investorOverview/common/customTable"
import { AmcTableBody, AmctableHeaderData } from "../investorOverview/mutualFund/common/Table"
import { Order, SortingObj } from "../investorOverview/types"

type CategoriesTableProps = {
    title: string
    tableData: any
    isLoading: boolean
    filters?: boolean
    handleTableSorting: (orderBy: string, order: Order) => void
    sortingObj: SortingObj,
    setSortingObj: ({ order, orderBy }: SortingObj) => void
    amcDownload: () => void
    amcDownloadLoader?: boolean;
}


export default function AMCPerformanceAnalysis(props: CategoriesTableProps): JSX.Element {
    const { title, tableData, isLoading, filters = true, handleTableSorting, sortingObj, setSortingObj, amcDownload, amcDownloadLoader } = props
    const { palette, typography } = useTheme()


    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
                {filters && (
                    <Tooltip
                        slotProps={{
                            tooltip: {
                                sx: {
                                    margin: "0px !important",
                                    backgroundColor: "transparent",
                                    wordWrap: 'normal'
                                }
                            }
                        }}
                        title={
                            <div
                                style={{
                                    borderRadius: '10px', backgroundColor: '#0F131F', padding: '10px'
                                }}
                            >
                                <span style={{ ...typography.subtitle_500, fontFamily: typography.fontFamily }}>Download AMC Performance analysis report</span>
                            </div>
                        }
                    >
                        {isLoading ? <></> : <Box display={'flex'} gap={'10px'}
                            onClick={amcDownload}
                        >
                            {amcDownloadLoader ? <CircularProgress size={20} /> :
                                <Box
                                    aria-label="Download AMC Performance Analysis"
                                    component={'button'}
                                    sx={{ cursor: 'pointer', border: 'none', display: 'flex', gap: '10px', background: 'transparent', alignItems: 'center' }}>
                                    <BlackDownloadIcon />
                                    <Typography
                                        color={palette.text.primary}
                                        sx={{ ...typography.body_500 }}

                                    >Download</Typography>
                                </Box>}
                        </Box>
                        }
                    </Tooltip>

                )}

            </Box>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={5}
                    isLoading={isLoading}
                    tableBody={
                        <AmcTableBody
                            tableBodyData={tableData || []}
                            handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                        />
                    }
                    tableData={tableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={AmctableHeaderData}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={handleTableSorting}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                />
            </Box>
        </Box>
    )
}
